/**
 * utils/seedData.js
 * Real IJM sample items — 7 SIDE GEAR spare parts used to prove the stock foundation.
 * Loaded on first run when localStorage is empty.
 *
 * Item shape: internalCode (PK), marketCodes (string[]), name, fitment, category,
 *   tipe, stokPusat, stokCabang, isSet, notes, minStock?
 */
import { creationEntries } from "./history";
import { seedBranches } from "./branches";

const seedItems = [
  { internalCode: "SG-00001", marketCodes: ["MB 241942"],              name: "SIDE GEAR", fitment: ["L038 STD", "L 300 Diesel"],        category: "SIDE GEAR", isSet: false, stokPusat: 698,  stokCabang: -550,  tipe: null, notes: "" },
  { internalCode: "SG-00002", marketCodes: ["MB 241942"],              name: "SIDE GEAR", fitment: ["L 300 AS BESAR Diesel"],              category: "SIDE GEAR", isSet: false, stokPusat: 0,    stokCabang: 270,   tipe: null, notes: "" },
  { internalCode: "SG-00003", marketCodes: ["MB 308115"],              name: "SIDE GEAR", fitment: ["PS 100"],                             category: "SIDE GEAR", isSet: false, stokPusat: 49,   stokCabang: 508,   tipe: null, notes: "" },
  { internalCode: "SG-00004", marketCodes: ["MB 308115"],              name: "SIDE GEAR", fitment: ["PS 100"],                             category: "SIDE GEAR", isSet: false, stokPusat: 0,    stokCabang: 32,    tipe: null, notes: "" },
  { internalCode: "SG-00005", marketCodes: ["FORD"],                   name: "SIDE GEAR", fitment: ["FORD 11TX30TX20T"],                   category: "SIDE GEAR", isSet: false, stokPusat: 1047, stokCabang: -129,  tipe: null, notes: "" },
  { internalCode: "SG-00006", marketCodes: ["MC 075141"],              name: "SIDE GEAR", fitment: ["FE 84", "PS 136 TRUK"],              category: "SIDE GEAR", isSet: false, stokPusat: 2193, stokCabang: -1785, tipe: null, notes: "" },
  { internalCode: "SG-00007", marketCodes: ["MK 610366", "ML 238"],    name: "SIDE GEAR", fitment: ["FE 84", "PS 136 BUS"],               category: "SIDE GEAR", isSet: false, stokPusat: 942,  stokCabang: 3322,  tipe: null, notes: "" },
];

export const seedManagedLists = {
  suppliers: ["RRC", "AWI", "ASUI", "GAS", "BARANG EX"],
  tipe: ["STD", "LS"],
};

/** Build a fresh seed data object (deep-cloned so callers never mutate the module's arrays). */
export function buildSeedData() {
  const items = JSON.parse(JSON.stringify(seedItems));
  return {
    items,
    transformations: [],
    history: items.flatMap((it) => creationEntries(it)),
    recipes: [],
    managedLists: JSON.parse(JSON.stringify(seedManagedLists)),
    categories: [{ name: "SIDE GEAR", code: "SG" }],
    cars: [
      { name: "L038 STD" }, { name: "L 300 Diesel" }, { name: "L 300 AS BESAR Diesel" },
      { name: "PS 100" }, { name: "FORD 11TX30TX20T" }, { name: "FE 84" },
      { name: "PS 136 TRUK" }, { name: "PS 136 BUS" },
    ],
    // Multi-branch cabang feature: a fresh install also needs the 3 real branches from day
    // one, not just an upgrading save (storage.js's v15->v16 migration) — seedBranches() is
    // the single shared source for both paths so they can never disagree.
    branches: seedBranches(),
  };
}
